import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16.578,1.593l5.225,6.217l-5.225,5.974",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}), /* @__PURE__ */ _jsx("path", {
			d: "M20.848,7.688l-10.168,0c0,0 -8.511,-0.562 -8.483,7.5c0.028,8.061 8.651,7.191 8.651,7.191l8.596,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		})]
	})
});
export default SvgRedo;
